export * as dataGridColumns from './dataGridColumns';
export * from './sidebarModes';
export { default as apexConfig } from './apexConfig';
export { default as skuSchema } from './skuSchema';
export { default as colors } from './colors';
export { default as paginationOptions } from './paginationOptions';
export * from './menuItems';

export const systemDateFormat = 'YYYY-MM-DD';
export const requestsRateLimit = 5;
export const LOCAL_STORAGE_ACC_VIEW_FILTERS = 'ccp:accounts-view:filters';

export enum Client {
  OPS = 'ops',
}

export enum Env {
  PROD = 'prod',
  DEV = 'dev',
}

export enum DataBillableType {
  ALL = 'all',
  BILLABLE = 'billable',
  NOT_BILLABLE = 'not_billable',
}

export enum Currency {
  USD = 'USD',
  EUR = 'EUR',
  GBP = 'GBP',
}

export enum GroupTraffic {
  ACCOUNT = 'account_id',
  ENVIRONMENT = 'environment_id',
  SKU = 'sku_fragment',
  FLOW = 'flow_id',
  NO_GROUPING = 'no_grouping',
}
